export default __webpack_public_path__ + "static/media/checkbox.ff28ec76.svg";